import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

// ASTT-7319: extracted from RichTextEditorField.js's own label rendering
// (Successes/Challenges/Topics Covered/Parking Lot all use this exact
// style already) -- the one already-consistent label pattern in this
// module, now made reusable so every other control (Email Distro,
// Curriculum Status, DTR Date, Class Roster Ids) can match it exactly
// instead of each having its own slightly different label styling
// (a plain <p>, MUI's internal label prop, or the differently-styled
// shared TextLabel component -- #3F5765/bold/0.10em spacing/Urbanist,
// vs. this one's #555/600 weight/0.04em spacing).
//
// mb: 0.5 (4px) is deliberately minimal -- label sits directly above its
// control with barely any gap, matching the reference pattern exactly.
export default function FieldLabel({ children }) {
  return (
    <Box
      component="span"
      sx={{
        display: "block",
        fontSize: "0.9rem",
        fontWeight: 600,
        color: "#555",
        letterSpacing: "0.04em",
        mb: 0.5,
      }}
    >
      {children}
    </Box>
  );
}

FieldLabel.propTypes = {
  children: PropTypes.node.isRequired,
};
